// extracted by mini-css-extract-plugin
export var divider = "_3i-0";
export var dividerText = "_3i-1";